module.exports = __webpack_public_path__ + "static/media/colorRed.853b7eb7.png";